import {
  AudioTags,
  tTaskAudioManagerItems
} from 'students/views/shared/bundles/audio/models';

import mp3BgMusic from './bg_music.mp3';

/** Namespaced per game: every game has its own `bg_music.mp3`. */
export const MatchWordAudioIds = {
  background: 'game:matchword:background'
} as const;

export const audioItems: tTaskAudioManagerItems = [
  {
    id: MatchWordAudioIds.background,
    tags: [AudioTags.MusicPlayback],
    src: mp3BgMusic,
    html5: false,
    autoplay: true,
    loop: true,
    volume: 0.1
  }
];
